import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
export default {
  __name: 'BackButton',
  props: {
    to: {
      type: String,
      default: '/'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var router = useRouter();
    function onClick() {
      var _window$history, _window$history$state;
      if (!window.history.length || (_window$history = window.history) !== null && _window$history !== void 0 && (_window$history$state = _window$history.state) !== null && _window$history$state !== void 0 && _window$history$state.isLastCasesPage) {
        router.replace(props.to);
      } else {
        router.back();
      }
    }
    return {
      __sfc: true,
      props: props,
      router: router,
      onClick: onClick
    };
  }
};